import React, { useEffect } from "react";
import logo1 from "../components/assets/visa.png";
import logo2 from "../components/assets/Rupay-Logo.png";
import logo3 from "../components/assets/footer1.png";
import logo4 from "../components/assets/footer2.png";
import logo5 from "../components/assets/footer3.png";
import { useDispatch, useSelector } from "react-redux";
import { GetCategory } from "./redux/slices/GetCategorySlice";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { AllCategory } = useSelector((state) => state?.category);

  useEffect(() => {
    dispatch(GetCategory());
  }, []);

  // const generateSlug = (text) => {
  //   if (!text) {
  //     // console.log("⚠️ Warning: Slug generation failed due to null value!");
  //     return "";
  //   }
  //   return text
  //     .replace(/[^\w\s-]/g, "")
  //     .replace(/\s+/g, "-")
  //     .replace(/-+/g, "-");
  // };

  const handleCategoryClick = (category) => {
    navigate(`/product-category/${category.name}/${category._id}`, {
      state: { category },
    });
  };

  return (
    <footer className="bg-black text-white py-10 text-left ">
      <div className="container mx-auto grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6 text-sm px-4">
        <div>
          <h3 className="font-bold mb-4">Find It Fast</h3>
          <ul>
            <li className="mb-2">
              <a
                href="/AllProductData"
                className="hover:underline text-gray-400"
              >
                All Stuff
              </a>
            </li>
            {AllCategory?.slice(0, 5).map((category) => (
              <li key={category._id} className="mb-2">
                <button
                  onClick={() => handleCategoryClick(category)}
                  className="hover:underline text-gray-400 line-clamp-1"
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">Other Policies</h3>
          <ul>
            <li className="mb-2">
              <a
                href="/return-policy/"
                className="hover:underline text-gray-400"
              >
                Return Policy
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/delivery-information/"
                className="hover:underline text-gray-400"
              >
                Delivery Policy
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/shipping-policy/"
                className="hover:underline text-gray-400"
              >
                Shipping Policy
              </a>
            </li>
            <li>
              <a
                href="/pricing-and-payments-policy/"
                className="hover:underline text-gray-400"
              >
                Payments Policy
              </a>
              <li className="mb-2 mt-2">
                <a
                  href="/disclaimer-policy/"
                  className="hover:underline text-gray-400"
                >
                  Disclaimer Policy
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/prebooking-terms-and-conditions/"
                  className="hover:underline text-gray-400"
                >
                  Prebooking Policy
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/cancellation-and-return-policy/"
                  className="hover:underline text-gray-400"
                >
                  Cancellation Policy
                </a>
              </li>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">Support</h3>
          <ul>
            <li className="mb-2">
              <a href="/faq/" className="hover:underline text-gray-400">
                FAQ
              </a>
            </li>
            <li className="mb-2">
              <a href="/about-us/" className="hover:underline text-gray-400">
                About US
              </a>
            </li>
            <li className="mb-2">
              <a href="/contact-us/" className="hover:underline text-gray-400">
                Contact US
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/refund-return/"
                className="hover:underline text-gray-400"
              >
                Refund & Return
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/terms-of-service/"
                className="hover:underline text-gray-400"
              >
                Terms Of Services
              </a>
            </li>
            <li className="mb-2">
              <a
                href="/privacy-policy"
                className="hover:underline text-gray-400"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="/track-your-order/"
                className="hover:underline text-gray-400"
              >
                Track your Order
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">More</h3>
          <ul>
            <li className="mb-2">
              <a href="/how-to/" className="hover:underline text-gray-400">
                How To
              </a>
            </li>
            <Link
              to="/all-cate"
              className="hover:text-red-500 transition duration-300 ease-in-out"
            >
              <li className=" hover:underline text-gray-400  cursor-pointer transition duration-200">
                Shop By Category
              </li>
            </Link>
            <Link
              to="/vendor-register/"
              className="hover:text-red-500 transition duration-300 ease-in-out"
            >
              <li className=" hover:underline text-gray-400  cursor-pointer transition duration-200 mt-2">
                Your Seller Account
              </li>
            </Link>
            <li className="mt-2">
              <a href="/my-account/" className="hover:underline text-gray-400">
                Login
              </a>
            </li>
          </ul>
        </div>

        <div className="">
          <h3 className="font-bold mb-4">ADDRESS</h3>
          <p className="mb-2 text-gray-400">
            Fliptwirls, Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001
          </p>
          <p className="mb-2 text-gray-400">
            Telephone:{" "}
            <a href="tel:18002029898" className="hover:underline text-blue-700">
              +91-8588819430
            </a>
          </p>
          <p className="mb-2 text-gray-400">
            <a href="tel:18002029898" className="hover:underline ">
              Email:  info@fliptwirls.com
            </a>
          </p>
        </div>
      </div>

      <div className="container mx-auto mt-6 border-t border-gray-700 pt-3 text-xs px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p>&copy; All Rights Reserved fliptwirls.com</p>
          <div className="flex flex-wrap gap-4 mt-4 md:mt-0 items-center">
            <img src={logo1} alt="Visa" className="w-12 h-6 object-cover" />
            <img src={logo2} alt="Rupay" className="w-14 h-12 object-cover" />
            <img
              src={logo3}
              alt="Footer Logo 1"
              className="w-12 h-6 object-cover"
            />
            <img
              src={logo4}
              alt="Footer Logo 2"
              className="w-12 h-6 object-cover"
            />
            <img
              src={logo5}
              alt="Footer Logo 3"
              className="w-12 h-6 object-cover"
            />
            <a href="/vendor-register/" className="hover:underline">
              Sell on fliptwirls
            </a>
            <a href="/Coupons" className="hover:underline">
              Gift Cards
            </a>
            <a className="hover:underline">Help Center</a>
            <a href="/track-your-order/" className="hover:underline">
              Track Orders
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
